import list from './list';
import detail from './detail';
import addCompare  from './addCompare';
import delCompare from './delCompare';
import delCompareDetail from './delCompareDetail';
import commitCompare from './commitCompare';
import queryCompare from  './queryCompare';
import queryImgUrl from './queryImgUrl';
import downloadCompare from './downloadCompare';

export default {
    list,
    detail,
    addCompare,
    delCompare,
    delCompareDetail,
    commitCompare,
    queryCompare,
    queryImgUrl,
    downloadCompare
};



// WEBPACK FOOTER //
// ./src/api/invoiceCompare/index.ts